import { computed, onMounted, onUnmounted, ref, type Ref } from 'vue'

const activeDropdownId = ref<string | null>(null)

export function useDropdown(id: string, containerRef: Ref<HTMLElement | null>) {
  const isOpen = computed(() => activeDropdownId.value === id)

  function toggle() {
    activeDropdownId.value = isOpen.value ? null : id
  }

  function close() {
    if (isOpen.value) activeDropdownId.value = null
  }

  function handleClickOutside(event: MouseEvent) {
    if (!isOpen.value) return
    if (containerRef.value && !containerRef.value.contains(event.target as Node)) {
      close()
    }
  }

  onMounted(() => document.addEventListener('mousedown', handleClickOutside))
  onUnmounted(() => document.removeEventListener('mousedown', handleClickOutside))

  return { isOpen, toggle, close }
}
